<button
  [type]="type"
  (click)="onClick($event)"
  [disabled]="disabled || loading"
  [ngClass]="[
    'px-2 sm:px-4 h-7 sm:h-9 text-[13px] shadow rounded-md sm:rounded-lg font-medium flex items-center justify-center gap-1',
    variant === 'outline'
      ? 'border !border-[#6729FF] text-[#6729FF]  bg-[#FFFFFF]'
      : '',
    variant === 'filled' ? '!bg-[#6729FF] text-[#FFFFFF] font-bold ' : '',
    disabled || loading ? 'opacity-50 cursor-not-allowed' : '',
    buttonClass
  ]"
>
  @if (loading) {
    <svg class="animate-spin h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  } @else {
    @if (iconLeft) {
      @if (isSvgIcon(iconLeft)) {
        <span [innerHTML]="safeIconLeft"></span>
      } @else {
        <span>{{ iconLeft }}</span>
      }
    }
  }
  <span [ngClass]="{ 'max-md:hidden': iconLeft || iconRight }">{{ loading ? 'Loading...' : label }}</span>
  @if (!loading && iconRight) {
    @if (isSvgIcon(iconRight)) {
      <span [innerHTML]="safeIconRight"></span>
    } @else {
      <span>{{ iconRight }}</span>
    }
  }
</button>

